module.exports = {"accessToken":"pk.eyJ1IjoibmluYXRoOTMiLCJhIjoiY2l1Z3hrNHdwMDA1dTJvdXZ3cHU1MXRtZCJ9.3Fvz0hxUYSPlii4gZ_LkiA","styles":{"light":"mapbox://styles/mapbox/light-v9","outdoors":"mapbox://styles/mapbox/outdoors-v9","leshine":"mapbox://styles/johnche/cjjsi81252gad2srjdyj17bqy","newStyle":"mapbox://styles/ninath93/cjjy88yn37rma2sqqaxobnhjp"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/MapboxWrapper/config.json
// module id = 228
// module chunks = 0